import { render, staticRenderFns } from "./db.vue?vue&type=template&id=d92eed1a"
import script from "./db.vue?vue&type=script&lang=ts"
export * from "./db.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports